import React from "react";
import { useState } from "react";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { useNavigate } from "react-router-dom";
import { AdsOrder } from "./AdsComponents";
import NotFound from "../NotFound";
import { Chip } from "@mui/material";




export default function AdsComponent({ itemsPerPage, items, onClickEdit, myAds }) {
  const [orderedItems, setOrderedItems] = useState([])
  const [paginatedItems, setPaginatedItems] = useState([])
  const { t } = useTranslation()
  const navigate = useNavigate()




  return (
    <>
      {!items.length ? <NotFound /> :
        <div className="container-fluid">
          <div className="row">


            <AdsOrder items={items} setOrderedItems={setOrderedItems} />

            {paginatedItems.map((ad, index) => {
              return (
                <div className="col-md-4" key={index}>
                  <div
                    className="front-card card h-90 shadow-lg mb-5"
                  >
                    <div style={{ height: 200, position: "relative" }}>
                      <img
                        src={ad.image ? `${Global.backend}/uploads/${ad.image}` : require("../../assets/img/default_product.png")}
                        className="card-img-top"
                        alt="..."
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {myAds && <Chip style={{ position: "absolute", right: 5, top: 5 }} className="ms-2" label={t(ad.etat ? (ad.etat == -1 ? "ads.rejected" : "ads.approved") : "ads.waiting")} color={ad.etat ? (ad.etat == -1 ? "error" : "success") : "info"} />}
                    </div>



                    <div className="card-body">

                      <div className="d-flex align-items-center">
                        <h5 className="card-title h-100" style={{
                          textWrap: "nowrap",
                          textOverflow: "ellipsis"
                        }}>
                          {ad.titre || "Ad"}
                        </h5>
                        {ad.user.id == localStorage.getItem("id") && <h6 className="text-primary h-100" style={{
                          textWrap: "nowrap",
                          textOverflow: "ellipsis"
                        }}>({t("yourAd")})</h6>}
                      </div>


                      <p style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                      }}>
                        {ad.description || "Ad..."}
                      </p>


                      <div className="text-center my-2">
                        <button
                          className="btn-lg rounded-pill"
                          style={{
                            backgroundColor: "#3f2414",
                            color: "white",
                          }}
                          onClick={() => {
                            if (onClickEdit) {
                              navigate("/dashboard/user/monannonce/" + ad.id);
                            } else {
                              navigate("/detailAnnonce/" + ad.id + "?categorie=" + ad.categorie);
                            }
                          }}
                        >
                          <>{t('consultAd')}</>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}

          </div>



          <Pagination itemsPerPage={itemsPerPage} items={orderedItems} setItems={setPaginatedItems} />
        </div>
      }
    </>
  );
}














